import { isLevel, Logger, transports } from 'libs/logger';

import { StorageValue } from 'utils/storage';

import { sentry } from './transports';

import config from 'config';

const levelValue = new StorageValue({ key: 'builder:log_level' });

export const logger = new Logger({
    transports: [transports.console, sentry],
});

logger.events.onLevelChange.on((value) => {
    levelValue.set(value);
});

export const initLogger = () => {
    const initialLevel = config.ENV === 'prod' ? 'error' : 'info';

    const levelFromStorage = levelValue.get();
    const level = isLevel(levelFromStorage) ? levelFromStorage : initialLevel;

    logger.level = level;
};
